import queryString from 'query-string';
/**
 * Create an image URL for ImageSharp
 * @param image The image model
 * @param imageParams The image parameters
 * @returns The image URL
 */
export function imageUrl(image, imageParams) {
    if (!image || !image.src) {
        return '';
    }
    function setQuality() {
        // If quality is set, use it.
        if (imageParams.quality) {
            return imageParams.quality;
        }
        // Default to 85 for images larger than 1000px.
        if (imageParams.width && imageParams.width > 1000) {
            return 85;
        }
        // Default to 95 for images larger than 480px.
        if (imageParams.width && imageParams.width > 480) {
            return 95;
        }
        return undefined;
    }
    /**
     * Remove any query param string to ensure paramsString is applied correctly and
     * there are no double definitions (setting a param twice prevents any tranformations)
     */
    const imageSource = image.src.split('?')[0];
    const params = {
        rxy: image.focalPoint ? `${image.focalPoint.left},${image.focalPoint.top}` : undefined,
        quality: setQuality(),
        ...imageParams,
    };
    const paramsString = queryString.stringify(params);
    return `${imageSource}${paramsString ? `?${queryString.stringify(params)}` : ''}`;
}
export function getSrcs(image, upper, lower, steps, ratio, params) {
    const sizes = getRange(upper, lower, steps);
    return sizes.map((size) => `${imageUrl(image, {
        width: size,
        height: ratio ? size * ratio : undefined,
        ...params,
    })} ${size}w`);
}
function getRange(upper, lower, steps) {
    const difference = upper - lower;
    const increment = difference / (steps - 1);
    return [
        lower,
        ...Array(steps - 2)
            .fill('')
            .map((_, index) => Math.ceil(lower + increment * (index + 1))),
        upper,
    ];
}
